import React from 'react';
import oshoMain from '../assets/osho_one.webp';
import oshoPortrait from '../assets/about_guru.jpg';

const AboutOsho = () => {
  return (
    <section id="about-osho" className="relative py-20 md:py-28 bg-cream overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="relative grid lg:grid-cols-2 gap-0 items-stretch">
          {/* Left image with decorative circle bg */}
          <div className="relative flex items-end justify-center bg-rose-soft rounded-l-3xl overflow-hidden min-h-[500px]">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[420px] h-[420px] rounded-full dashed-circle flex items-center justify-center">
                <div className="w-[360px] h-[360px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(247,213,218,0.9), rgba(238,177,186,0.5))' }} />
              </div>
            </div>
            <img
              src={oshoMain}
              alt="Osho Universal"
              className="relative z-10 max-h-[520px] object-contain object-bottom"
              style={{ filter: 'drop-shadow(0 20px 30px rgba(74,23,33,0.25))' }}
            />
          </div>

          {/* Right content */}
          <div className="relative bg-rose-deep p-10 md:p-14 rounded-r-3xl flex flex-col justify-center">
            {/* Floating small image top */}
            <div className="absolute -top-12 right-10 w-28 h-32 rounded-2xl overflow-hidden border-4 border-cream shadow-lg">
              <img src={oshoPortrait} alt="Osho" className="w-full h-full object-cover object-top" />
            </div>

            <h3 className="font-serif-display text-burgundy text-4xl md:text-5xl">About</h3>
            <h4 className="font-italic-display text-mahogany text-4xl md:text-5xl mt-1">Osho Universal</h4>

            <div className="mt-6 space-y-4 text-burgundy/90 leading-relaxed max-w-xl">
              <p>
                Osho Universal is an effort to bring community of meditators together and connect to Osho Ashrams, Meditation centers, Meditation Facilitators and Seekers. Osho is one path in endless paths to human liberation, salvation, enlightenment.
              </p>
              <p>
                We here at Osho Universal look forward to share Osho meditation techniques designed for the modern mind. Perfect antidote to all mental sicknesses including depression, anxiety, stress and can lead to ultimate self realization and spiritual liberation through love and awareness.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOsho;
